<template>
  <div class="container">
    <div class="header">
      <a-select v-model:value="selectedMonth" style="width: 200px;">
        <a-select-option value="2025-6">2025-6</a-select-option>
        <a-select-option value="2025-5">2025-5</a-select-option>
        <a-select-option value="2025-4">2025-4</a-select-option>
        <a-select-option value="2025-3">2025-3</a-select-option>
      </a-select>
    </div>
    <div class="chart-container">
      <div class="chart-row">
        <div ref="chart1" class="chart"></div>
        <div ref="chart2" class="chart"></div>
      </div>
      <div class="chart-row">
        <div ref="chart3" class="chart"></div>
        <div ref="chart4" class="chart"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as ECharts from "echarts";

export default {
  name: "EventCharts",
  data() {
    return {
      selectedMonth: "2025-6",
      charts: [] // 用于存储所有图表实例
    }
  },
  mounted() {
    this.initCharts();
    // 监听窗口大小变化，自动调整图表大小
    window.addEventListener('resize', this.resizeCharts);
  },
  beforeUnmount() {
    // 移除事件监听，避免内存泄漏
    window.removeEventListener('resize', this.resizeCharts);
    // 清除图表实例
    this.charts.forEach(chart => {
      chart.dispose();
    });
    this.charts = [];
  },
  methods: {
    initCharts() {
      this.initChart1();
      this.initChart2();
      this.initChart3();
      this.initChart4();
      // 初始调整一次大小
      setTimeout(() => {
        this.resizeCharts();
      }, 100);
    },
    // 重新调整所有图表大小
    resizeCharts() {
      this.charts.forEach(chart => {
        chart && chart.resize();
      });
    },
    initChart1() {
      let chart1 = ECharts.init(this.$refs.chart1);
      this.charts.push(chart1); // 保存图表实例
      
      // 构造日期数组（1号到30号）
      var days = [];
      for (var i = 1; i <= 30; i++) {
        days.push(i + '号');
      }

      // 模拟数据
      var totalEvents = Array.from({length: 30}, () => Math.floor(Math.random() * 20) + 5); // 每天5~25个事件
      var completedEvents = totalEvents.map(count => Math.floor(count * Math.random())); // 随机完成部分
      var pendingEvents = totalEvents.map((count, i) => count - completedEvents[i]);

      var option = {
        title: {
          text: '每日事件完成情况',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['已完成', '未完成'],
          top: 30
        },
        xAxis: {
          type: 'category',
          data: days
        },
        yAxis: {
          type: 'value',
          name: '事件数量'
        },
        series: [
          {
            name: '已完成',
            type: 'bar',
            stack: 'total',
            data: completedEvents,
            itemStyle: {color: '#73C088'}
          },
          {
            name: '未完成',
            type: 'bar',
            stack: 'total',
            data: pendingEvents,
            itemStyle: {color: '#C0C0C0'}
          }
        ]
      }
      chart1.setOption(option);
    },
    initChart2() {
      let chart2 = ECharts.init(this.$refs.chart2);
      this.charts.push(chart2); // 保存图表实例
      
      let option = {
        title: {
          text: '当月事件类别统计',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            name: '事件类别',
            type: 'pie',
            radius: '60%',
            data: [
              {value: 23, name: '垃圾堆放'},
              {value: 15, name: '道路损坏'},
              {value: 12, name: '泊车问题'},
              {value: 9, name: '井盖问题'},
              {value: 18, name: '草坪维护'}
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };

      chart2.setOption(option);
    },
    initChart3() {
      let chart3 = ECharts.init(this.$refs.chart3);
      this.charts.push(chart3); // 保存图表实例

      var vendors = [
        "迅捷管道工程",
        "绿净环境服务",
        "四季园林",
        "安泊智能",
        "园区万事达"
      ];

      var completed = [42, 35, 50, 28, 40];
      var total = [50, 40, 55, 35, 50];
      var completionRate = completed.map((val, idx) => ((val / total[idx]) * 100).toFixed(1));

      var option = {
        backgroundColor: '#fff',
        title: {
          text: '服务商事件完成情况',
          left: 'center',
          top: 0,
          textStyle: {
            fontSize: 20,
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          formatter: function (params) {
            let bar = params.find(p => p.seriesType === 'bar');
            let line = params.find(p => p.seriesType === 'line');
            return `
            ${bar.name}<br/>
            完成数量: ${bar.data}<br/>
            完成率: ${line.data}%
          `;
          }
        },
        legend: {
          data: ['完成数量', '完成率'],
          top: 24
        },
        grid: {
          left: '8%',
          right: '8%',
          bottom: '18%',        // 增加底部间距，防止标签被遮挡
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: vendors,
          axisLabel: {
            rotate: 45,          // 由30改为45度，更斜一点
            fontSize: 12,
            interval: 0,         // 保证每个标签都显示
            formatter: function(value) {
              // 如果太长可以分行（每4个字符换行）
              if (value.length > 6) {
                return value.replace(/(.{4})/g, '$1\n');
              }
              return value;
            }
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '完成数量',
            axisLine: { lineStyle: { color: '#5470C6' } }
          },
          {
            type: 'value',
            name: '完成率 (%)',
            max: 100,
            axisLine: { lineStyle: { color: '#91CC75' } }
          }
        ],
        series: [
          {
            name: '完成数量',
            type: 'bar',
            data: completed,
            barWidth: '40%',
            itemStyle: {
              color: '#5470C6',
              borderRadius: [4, 4, 0, 0],
              shadowColor: 'rgba(0,0,0,0.1)',
              shadowBlur: 6
            },
            label: {
              show: true,
              position: 'top',
              color: '#333',
              fontWeight: 'bold'
            }
          },
          {
            name: '完成率',
            type: 'line',
            yAxisIndex: 1,
            data: completionRate,
            itemStyle: {
              color: '#73C088'
            },
            symbol: 'circle',
            symbolSize: 10,
            lineStyle: {
              width: 3
            },
            label: {
              show: true,
              formatter: '{c}%',
              position: 'top',
              fontWeight: 'bold'
            }
          }
        ]
      };


      chart3.setOption(option);
    },
    initChart4() {
      let chart4 = ECharts.init(this.$refs.chart4);
      this.charts.push(chart4); // 保存图表实例
      
      var option = {
        title: {
          text: '事件来源统计',
          left: 'center',
          top: 20,
          textStyle: {
            fontSize: 20,
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          top: 50
        },
        series: [
          {
            name: '事件来源',
            type: 'pie',
            radius: '60%',
            data: [
              { value: 120, name: '公众上报' },
              { value: 80, name: '人员巡检' },
              { value: 60, name: '无人机巡检' },
              { value: 40, name: '巡检车巡检' }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 15,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              formatter: '{b}: {d}%',
              fontSize: 14,
              fontWeight: 'bold'
            }
          }
        ]
      };

      chart4.setOption(option);
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  height: auto; /* 改为自动高度 */
  overflow: visible; /* 移除滚动条，使用父容器滚动 */
  display: flex;
  flex-direction: column;
}

.header {
  display: flex;
  justify-content: flex-end;
  padding: 10px 20px;
  margin-bottom: 10px;
}

.chart-container {
  display: flex;
  flex-direction: column;
  padding: 0 20px 80px 20px; /* 保持底部内边距 */
}

.chart-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 50px; /* 保持行间距 */
  width: 100%;
  min-height: 380px; /* 确保最小高度 */
}

.chart {
  width: 48%; /* 保持宽度 */
  height: 350px; /* 保持图表高度 */
}

/* 为了确保在小屏幕上也能看到完整内容 */
@media (max-height: 900px) {
  .chart {
    height: 300px;
  }
  
  .chart-row {
    min-height: 320px;
  }
}
</style>